import posthog from 'posthog-js';
import { withAppData } from '~/analytics';
import { isNotProduction } from '~/stage';
import type { User } from '~/types';

export const analytics = {
  identify: (user: User) => {
    if (isNotProduction()) return;

    posthog.identify(user.id, withAppData(user));
  },

  track: async (name: string, data?: unknown) => {
    if (isNotProduction()) {
      console.info('[analytics]', 'track', name, data ?? {});
      return;
    }

    posthog.capture(name, withAppData(data));
  },

  reset: async () => {
    if (isNotProduction()) {
      console.info('[analytics]', 'reset');
      return;
    }

    posthog.reset();
  },
};
